import Menu from "@/router/menu";

const routes = [];
Menu.forEach((parent) => {
  // Les items sans path ne génèrent pas de route (ex. liens externes comme l'assistance)
  if (!parent.path) {
    return;
  }

  /** Si le parent a un nom on le push */
  if (parent.name) {
    const parentRoute = {
      path: parent.path,
      component: parent.component,
      name: parent.name,
      redirect: parent.redirect,
      beforeEnter: parent.beforeEnter,
      meta: {
        accessNotLogged: parent.accessNotLogged || parent.cataloguePublic,
        cataloguePublic: parent.cataloguePublic,
      },
    };
    if (parent.alias) {
      parentRoute.alias = parent.alias;
    }
    routes.push(parentRoute);
  }

  const children = parent.submenu || [];
  children.forEach((child) => {
    /** Génération des routes enfants */
    const childRoute = {
      path: parent.path + child.path,
      component: child.component,
      name: `${parent.name}_${child.name}`,
      redirect: child.redirect,
      beforeEnter: child.beforeEnter,
      meta: {
        title: child.title,
        icon: child.icon,
        goBackBtn: child.goBackBtn,
        permissions: child.permissions,
        accessNotLogged: child.accessNotLogged || child.cataloguePublic,
        cataloguePublic: child.cataloguePublic,
      },
    };
    if (
      parent.name === "catalogues"
      && ["livres_manuels_papier", "ressources_numeriques", "fournitures_papeterie"].includes(child.name)
    ) {
      childRoute.path = `${parent.path}/:catalogueSlug?`;
      childRoute.props = (route) => ({
        catalogueSlug: route.params.catalogueSlug || null,
      });
      // Les 3 routes partagent le même path : le router matche toujours la première.
      // On force accessNotLogged pour laisser le beforeEnter rediriger vers le bon type,
      // en conservant le gardien cataloguePublic (login requis si catalogue public inactif).
      childRoute.meta.accessNotLogged = true;
      childRoute.meta.cataloguePublic = true;
    }
    if (child.alias && parent.alias) {
      childRoute.alias = child.alias.map((alias, index) => {
        const baseAlias = parent.alias[index] + alias;
        if (
          parent.name === "catalogues"
          && ["livres_manuels_papier", "ressources_numeriques", "fournitures_papeterie"].includes(child.name)
        ) {
          return `${baseAlias}/:catalogueSlug?`;
        }
        return baseAlias;
      });
    }
    routes.push(childRoute);

    /** Génération des routes "petits-enfants" */
    const grandChildren = child.submenu || [];
    grandChildren.forEach((subchild) => {
      const grandChildRoute = {
        path: parent.path + child.path + subchild.path,
        component: subchild.component,
        name: `${parent.name}_${child.name}_${subchild.name}`,
        beforeEnter: child.beforeEnter,
        meta: {
          title: subchild.title,
          parent: `${parent.name}_${child.name}`,
          icon: subchild.icon,
          goBackBtn: subchild.goBackBtn,
          permissions: subchild.permissions,
          accessNotLogged: subchild.accessNotLogged || subchild.cataloguePublic,
          cataloguePublic: subchild.cataloguePublic,
        },
      };
      if (subchild.alias && parent.alias && child.alias) {
        grandChildRoute.alias = subchild.alias.map((alias, index) => parent.alias[index] + child.alias[index] + alias);
      }
      routes.push(grandChildRoute);
    });
  });
});
export default routes;
